/** One screen-access rule book, driven by the permission matrix. Used by routes and the sidebar. */
export const SCREENS = {
  "/dashboard": {},
  "/inventory": { module: "vehicles" },
  "/inventory/new": { module: "vehicles", action: "create" },
  "/inventory/:id": { module: "vehicles" },
  "/inventory/:id/edit": { module: "vehicles", action: "edit" },
  "/customers": { module: "customers" },
  "/customers/:id": { module: "customers" },
  "/sales": { module: "sales" },
  "/payments": { module: "payments" },
  "/online-payments": { module: "payments" },
  "/documents": { module: "documents" },
  "/forms": { module: "forms" },
  "/forms/sf": { roles: ["management", "sales", "accounts", "viewer"] },
  "/commissions": { roles: ["management"] },
  "/reports": { module: "reports" },
  "/live-chat": { module: "chat" },
  "/users": { module: "users" },
  "/permissions": { adminOnly: true },
  "/activity": { roles: ["admin", "management"] },
  "/settings": { adminOnly: true },
  "/social/accounts": { module: "social_accounts" },
  "/social/suggestions": { module: "social" },
  "/social/samples": { adminOnly: true },
};

export function canOpen(screen, user, can) {
  const rule = SCREENS[screen];
  if (!rule || !user) return false;
  if (user.role === "admin") return true;
  if (rule.adminOnly) return false;
  if (rule.roles) return rule.roles.includes(user.role);
  if (!rule.module) return true;
  return can(rule.module, rule.action || "view");
}
